interface Environment {
	ritchieIdApiUrl: string;
	auth0Domain: string;
	rawTenantDomain: string;
	clientId: string;
	redirectUri: string;
	resourcesBaseUri: string;
	scopes: string;
	mfaScopes: string;
	databaseName: 'RitchieID';
}

interface Config {
	LOCAL: Environment;
	DEV: Environment;
	QA: Environment;
	UAT: Environment;
	PROD: Environment;
}

const commonScopes = 'read:identities update:identities';
const commonMfaScopes = 'enroll read:authenticators remove:authenticators';

const config: Config = {
	LOCAL: {
		ritchieIdApiUrl: 'https://api.dev.test-rid.com/',
		auth0Domain: 'dev-id.ritchiebros.com',
		rawTenantDomain: 'dev-id.ritchiebros-dev.auth0.com',
		clientId: 'u0DMrWZeD70uu3BjxmfYuDEWBwcN060C',
		redirectUri: 'http://localhost:8080',
		resourcesBaseUri: 'https://dofgcv4m5vc2.cloudfront.net/images',
		databaseName: 'RitchieID',
		scopes: commonScopes,
		mfaScopes: commonMfaScopes
	},
	DEV: {
		ritchieIdApiUrl: 'https://api.dev.test-rid.com/',
		auth0Domain: 'dev-id.ritchiebros.com',
		rawTenantDomain: 'dev-id.ritchiebros-dev.auth0.com',
		clientId: 'u0DMrWZeD70uu3BjxmfYuDEWBwcN060C',
		redirectUri: 'https://manage-id.dev.test-rid.com/',
		resourcesBaseUri: 'https://dofgcv4m5vc2.cloudfront.net/images',
		databaseName: 'RitchieID',
		scopes: commonScopes,
		mfaScopes: commonMfaScopes
	},
	QA: {
		ritchieIdApiUrl: 'https://api.qa.test-rid.com/',
		auth0Domain: 'qa-id.ritchiebros.com',
		rawTenantDomain: 'qa-id.ritchiebros-dev.auth0.com',
		clientId: 'XGKxVnv7j66D0KKI9cTZsoYLXJMreTPa',
		redirectUri: 'https://manage-id.qa.test-rid.com/',
		resourcesBaseUri: 'https://dofgcv4m5vc2.cloudfront.net/images',
		databaseName: 'RitchieID',
		scopes: commonScopes,
		mfaScopes: commonMfaScopes
	},
	UAT: {
		ritchieIdApiUrl: 'https://api.uat.test-rid.com/',
		auth0Domain: 'uat-id.ritchiebros.com',
		rawTenantDomain: 'uat-id.ritchiebros-dev.auth0.com',
		clientId: 'rJZwVOY9AeehlnJFPprOwOQMVj1zVePA',
		redirectUri: 'https://manage-id.uat.test-rid.com/',
		resourcesBaseUri: 'https://dofgcv4m5vc2.cloudfront.net/images',
		databaseName: 'RitchieID',
		scopes: commonScopes,
		mfaScopes: commonMfaScopes
	},
	PROD: {
		ritchieIdApiUrl: 'https://api.idapps.ritchiebros.com/',
		auth0Domain: 'id.ritchiebros.com',
		rawTenantDomain: 'prod-id.ritchiebros.auth0.com',
		clientId: 'x7G63b5mjbzYLuGY91503Kz0EVv9FMjM',
		redirectUri: 'https://manage.idapps.ritchiebros.com/',
		resourcesBaseUri: 'https://d3o7edu1jfpavb.cloudfront.net/images',
		databaseName: 'RitchieID',
		scopes: commonScopes,
		mfaScopes: commonMfaScopes
	}
};

function getEnv(): 'LOCAL' | 'DEV' | 'QA' | 'UAT' | 'PROD' {
	let env = process.env.REACT_APP_ENV || '';

	if (env === 'LOCAL') return env;
	if (env === 'DEV') return env;
	if (env === 'QA') return env;
	if (env === 'UAT') return env;
	if (env === 'PROD') return env;

	console.warn('Environment is not equal to LOCAL, DEV, QA, UAT or PROD. Defaulting to LOCAL.');
	return 'LOCAL';
}

export const ENV = getEnv();

export const {
	ritchieIdApiUrl,
	auth0Domain,
	rawTenantDomain,
	clientId,
	redirectUri,
	resourcesBaseUri,
	databaseName,
	scopes,
	mfaScopes
} = config[ENV];